import React from 'react';
import { Icon, IconName } from '@blueprintjs/core';
import type { FeatureCardProps } from '../../types';
import './FeatureCard.scss';

const FeatureCard: React.FC<FeatureCardProps> = ({ feature }) => {
  return (
    <article className="feature-card">
      <div className="feature-card__icon">
        <Icon icon={feature.icon as IconName} size={32} />
      </div>
      <h3 className="feature-card__title">{feature.title}</h3>
      <p className="feature-card__description">{feature.description}</p>
    </article>
  );
};

export default FeatureCard;
